import { z } from 'zod';

import { GenderEnum } from '../../enums';
import { levelEnumValidator } from '../../validators';
import { TranslationsSchema } from '../words';

export const TranslateWordResponseSchema = z.object({
  gender: z.nativeEnum(GenderEnum).nullable(),
  level: levelEnumValidator.nullable(),
  plural: z.string().nullable(),
  text: z.string().min(1, 'Text cannot be empty'),
  translations: TranslationsSchema,
});

export type ITranslateWordResponseDto = z.infer<
  typeof TranslateWordResponseSchema
>;
